import { Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions, BMEnterFrameEvent } from 'ngx-lottie';

const FRAMES = 24;
const ANIMATION_DURATION = FRAMES * 1.5;
const ANIMATION_MARGIN = ANIMATION_DURATION / 2;

const PROFILES = [
  {
    color: 'bg-orange',
    frame: [FRAMES * 0, FRAMES * 2 - ANIMATION_MARGIN],
  },
  {
    color: 'bg-pink',
    frame: [FRAMES * 2 - ANIMATION_MARGIN, FRAMES * 5 - ANIMATION_MARGIN],
  },
  {
    color: 'bg-blue',
    frame: [FRAMES * 5 - ANIMATION_MARGIN, FRAMES * 8 - ANIMATION_MARGIN],
  },
  {
    color: 'bg-yellow',
    frame: [FRAMES * 8 - ANIMATION_MARGIN, FRAMES * 11 - ANIMATION_MARGIN],
  },
  {
    color: 'bg-dark-blue',
    frame: [FRAMES * 11 - ANIMATION_MARGIN, FRAMES * 14 - ANIMATION_MARGIN],
  },
  {
    color: 'bg-orange',
    frame: [FRAMES * 14 - ANIMATION_MARGIN, FRAMES * 16],
  },
];

@Component({
  selector: 'placeme-animate-profile',
  templateUrl: './animate-profile.component.html',
  styleUrls: ['./animate-profile.component.scss'],
})
export class AnimateProfileComponent implements OnInit {
  bgColorClass: string;
  lottieOptions: AnimationOptions;

  constructor(private translateService: TranslateService) {}

  enterFrame(event: BMEnterFrameEvent): void {
    const currentTime = event.currentTime;
    this.bgColorClass = PROFILES.find(p => currentTime >= p.frame[0] && currentTime <= p.frame[1]).color;
  }

  ngOnInit(): void {
    this.translateService.get('homePage').subscribe(() => {
      this.lottieOptions = {
        path: '/assets/lottie/profiles.json',
      };
    });
  }
}
